module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-09.23d639bf.jpg";